import { getPersistedExperimentTreatment } from '@ms/yammer-data/dist/domains/experiments/selectors';
import { Experiment } from '@ms/yammer-data/dist/state/types';
import { TelemetryClientId } from '@ms/yammer-data/dist/telemetry';
import { MetaOsHubName } from '@ms/yammer-web-support/dist/metaOsHub';
import { isInVivaConnectionsApp } from 'vivaConnections';

import { persistConfig } from '../../persistedState';
import { VivaEngageAppEntityId, getContext } from '../../teams/context';

export enum TelemetryClientIdType {
  YammerTeams = 'YAMMER_TEAMS',
  YammerTeamsPersonalApp = 'YAMMER_TEAMS_PERSONAL_APP',
  YammerMetaOsOutlookPersonalApp = 'YAMMER_METAOS_OUTLOOK_PERSONAL_APP',
  YammerMetaOsOfficePersonalApp = 'YAMMER_METAOS_OFFICE_PERSONAL_APP',
  YammerVivaConnections = 'YAMMER_VIVA_CONNECTIONS',
  YammerVivaEngagePersonalApp = 'YAMMER_VIVAENGAGE_PERSONAL_APP',
  YammerVivaEngageOutlookPersonalApp = 'YAMMER_VIVAENGAGE_OUTLOOK_PERSONAL_APP',
  YammerVivaEngageOfficePersonalApp = 'YAMMER_VIVAENGAGE_OFFICE_PERSONAL_APP',
}

type GetTelemetryClientId = () => Promise<TelemetryClientId>;
export const getTelemetryClientId: GetTelemetryClientId = async () => {
  if (isInVivaConnectionsApp()) {
    return TelemetryClientIdType.YammerVivaConnections;
  }

  try {
    const { appType, hubName, entityId } = await getContext();
    const vivaEngageExperimentTreatment = await getPersistedExperimentTreatment(
      persistConfig.key,
      Experiment.VivaEngageAppUXMC
    );

    const isVivaEngageApp =
      entityId === VivaEngageAppEntityId &&
      (vivaEngageExperimentTreatment === 'control' || vivaEngageExperimentTreatment === 'treatment');

    if (isVivaEngageApp) {
      if (hubName === MetaOsHubName.Outlook) {
        return TelemetryClientIdType.YammerVivaEngageOutlookPersonalApp;
      }

      if (hubName === MetaOsHubName.Office) {
        return TelemetryClientIdType.YammerVivaEngageOfficePersonalApp;
      }

      return TelemetryClientIdType.YammerVivaEngagePersonalApp;
    }

    if (hubName === MetaOsHubName.Outlook) {
      return TelemetryClientIdType.YammerMetaOsOutlookPersonalApp;
    }

    if (hubName === MetaOsHubName.Office) {
      return TelemetryClientIdType.YammerMetaOsOfficePersonalApp;
    }

    if (appType === 'tab') {
      return TelemetryClientIdType.YammerTeams;
    }

    return TelemetryClientIdType.YammerTeamsPersonalApp;
  } catch {
    //continue regardless of error
  }

  return TelemetryClientIdType.YammerTeamsPersonalApp;
};
